/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OverallMaturityResponse
 */
export interface OverallMaturityResponse {
    /**
     * 
     * @type {number}
     * @memberof OverallMaturityResponse
     */
    overallMaturity?: number;
}

/**
 * Check if a given object implements the OverallMaturityResponse interface.
 */
export function instanceOfOverallMaturityResponse(value: object): value is OverallMaturityResponse {
    return true;
}

export function OverallMaturityResponseFromJSON(json: any): OverallMaturityResponse {
    return OverallMaturityResponseFromJSONTyped(json, false);
}

export function OverallMaturityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OverallMaturityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'overallMaturity': json['overallMaturity'] == null ? undefined : json['overallMaturity'],
    };
}

export function OverallMaturityResponseToJSON(json: any): OverallMaturityResponse {
    return OverallMaturityResponseToJSONTyped(json, false);
}

export function OverallMaturityResponseToJSONTyped(value?: OverallMaturityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'overallMaturity': value['overallMaturity'],
    };
}

